// yAxisBounds keeps a near-flat series reading as flat instead of being
// auto-zoomed into a dramatic cliff: the visible span is never narrower than
// ~6% of the price level. A genuinely large swing scales normally. Centered on
// the data with headroom so the line does not touch the frame.
export function yAxisBounds(values: number[]): { min: number; max: number } {
  const lo = Math.min(...values);
  const hi = Math.max(...values);
  const center = (lo + hi) / 2;
  const minSpan = Math.max(center * 0.06, 0.01);
  const span = Math.max(hi - lo, minSpan);
  const half = span / 2 + span * 0.18;

  return { min: Math.max(0, center - half), max: center + half };
}
